
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Database } from "@/integrations/supabase/types";

type TimeOfDay = Database["public"]["Enums"]["time_of_day"];

interface TimeSectionProps {
  selectedTimes: TimeOfDay[];
  onTimeSelect: (times: TimeOfDay[]) => void;
  error?: string;
}

export const TimeSection = ({
  selectedTimes,
  onTimeSelect,
  error
}: TimeSectionProps) => {
  const toggleTimeOfDay = (time: TimeOfDay) => {
    if (selectedTimes.includes(time)) {
      // Remove time if it's already selected
      onTimeSelect(selectedTimes.filter(t => t !== time));
    } else {
      // Add time if it's not selected
      onTimeSelect([...selectedTimes, time]);
    }
  };

  const timeOptions: { label: string; value: TimeOfDay }[] = [
    { label: "Morning", value: "morning" },
    { label: "Afternoon", value: "afternoon" },
    { label: "Evening", value: "evening" },
  ];

  return (
    <div className="space-y-2">
      <Label>Time of Day</Label>
      <div className={cn(
        "flex flex-wrap gap-2",
        error && "border border-destructive rounded-lg p-2"
      )}>
        {timeOptions.map(({ label, value }) => (
          <Button
            key={value}
            type="button"
            variant={selectedTimes.includes(value) ? "default" : "secondary"}
            onClick={() => toggleTimeOfDay(value)}
            className={cn(
              "flex-1 min-w-[100px]",
              selectedTimes.includes(value) 
                ? "bg-primary text-primary-foreground hover:bg-primary/90" 
                : "bg-secondary text-secondary-foreground hover:bg-secondary/80"
            )}
          >
            {label}
          </Button>
        ))}
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};
